module.exports = __webpack_public_path__ + "img/left_bottom_3.014a334.png";